import { render } from "./OrderBackSummary.vue?vue&type=template&id=5b9846c5"
import script from "./OrderBackSummary.vue?vue&type=script&lang=js"
export * from "./OrderBackSummary.vue?vue&type=script&lang=js"

import "./OrderBackSummary.vue?vue&type=style&index=0&id=5b9846c5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__